import * as React from "react";
import { IconProps } from "../types";

const CircleHalfDottedClockIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_3215_9809)">
          <path
            d="M6 12.5C5.586 12.5 5.25 12.164 5.25 11.75C5.25 11.336 5.586 11 6 11C8.481 11 10.5 8.981 10.5 6.5C10.5 4.019 8.48 2 6 2C5.586 2 5.25 1.664 5.25 1.25C5.25 0.836 5.586 0.5 6 0.5C9.308 0.5 12 3.191 12 6.5C12 9.809 9.309 12.5 6 12.5Z"
            fill={color}
          />
          <path
            d="M8.00001 9C7.82501 9 7.64901 8.939 7.50701 8.814L5.50701 7.064C5.34401 6.921 5.25101 6.716 5.25101 6.5V3.75C5.25101 3.336 5.58701 3 6.00101 3C6.41501 3 6.75101 3.336 6.75101 3.75V6.16L8.49501 7.686C8.80701 7.959 8.83901 8.433 8.56601 8.744C8.41801 8.913 8.21001 9 8.00101 9H8.00001Z"
            fill={color}
          />
          <path
            d="M0.75 7.25C1.16421 7.25 1.5 6.91421 1.5 6.5C1.5 6.08579 1.16421 5.75 0.75 5.75C0.335786 5.75 0 6.08579 0 6.5C0 6.91421 0.335786 7.25 0.75 7.25Z"
            fill={color}
          />
          <path
            d="M1.82801 3.22501C1.46901 3.01801 1.01101 3.14101 0.803013 3.50001C0.596013 3.85901 0.719012 4.31701 1.07801 4.52401C1.43701 4.73101 1.89501 4.60801 2.10301 4.25001C2.31001 3.89101 2.18701 3.43301 1.82801 3.22501Z"
            fill={color}
          />
          <path
            d="M3.75001 2.60311C4.10901 2.39611 4.23201 1.93711 4.02501 1.57911C3.81801 1.22011 3.35901 1.09711 3.00001 1.30411C2.64101 1.51111 2.51801 1.97011 2.72501 2.32911C2.93201 2.68811 3.39101 2.81111 3.75001 2.60311Z"
            fill={color}
          />
          <path
            d="M1.07801 8.47501C0.719012 8.68201 0.596013 9.14101 0.803013 9.50001C1.01001 9.85901 1.46901 9.98201 1.82801 9.77401C2.18701 9.56701 2.31001 9.10801 2.10301 8.75001C1.89601 8.39101 1.43701 8.26801 1.07801 8.47501Z"
            fill={color}
          />
          <path
            d="M3.75001 10.3969C3.39101 10.1899 2.93301 10.3129 2.72501 10.6719C2.51801 11.0309 2.64101 11.4889 3.00001 11.6969C3.35901 11.9039 3.81701 11.7809 4.02501 11.4219C4.23201 11.0629 4.10901 10.6049 3.75001 10.3969Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_3215_9809">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default CircleHalfDottedClockIcon;
